import React from 'react';
import _ from 'lodash';
import styles from './UserEditPermissions.module.css';

export default class UserEditPermissions extends React.Component {
    constructor(props) {
        super(props);

        var initialState = {};

        if (props.permissions) {
            _.forEach(props.permissions, p => {
                Object.assign(initialState, {
                    ["Permission_" + p.id]: (props.privileges ? _.some(props.privileges, ['id', p.id]): false)
                });
            });
        }

        this.state = initialState;

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({
            [event.target.name]: (event.target.type === 'checkbox') ? event.target.checked: event.target.value
        });
    }

    render() {

        var permissionFields = null;

        if (this.props.permissions) {
            var sortedPermissions = _.sortBy(this.props.permissions, ['page_order']);

            permissionFields = sortedPermissions.map(
                (p) => {

                    var description = _.replace(p.description, new RegExp('&nbsp;', 'g'), '\u00A0\u00A0');
                    var descriptionLabel = _.trimStart(description);

                    var leadingSpaces = _.dropRight(description, descriptionLabel.length);

                    return (
                        <div className="form-group form-group-sm" key={"Permission_" + p.id}>
                            <div className="col-xs-10 col-sm-10 col-md-10 col-lg-8">
                                <div className="checkbox">
                                    <label>
                                        {description}
                                    </label>
                                </div>
                            </div>
                            <div className="col-xs-1 col-sm-1 col-md-1 col-lg-1">
                                <div className="checkbox">
                                    <input id={"inputPermission_" + p.id} name={"Permission_" + p.id} type="checkbox" checked={this.state["Permission_" + p.id]} onChange={this.handleChange} />
                                </div>
                            </div>
                        </div>
                    );
                }
            );
        }

        return (
            <fieldset>
                <legend className="groupHeader">Permissions</legend>
                {permissionFields}
            </fieldset>
            );
    }
}